import { isEmpty } from "lodash";
import React, { createContext, useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

// import { setAppConfig } from "../efficiencySlice";
import Modal from "react-bootstrap/Modal";
import CustomModal from "../../../../app/common-components/CustomModal";
import Input from "../../../../app/common-components/form/input";

// import Pagination from "../../../app/common-components/pagination";
import { Col, Row } from "react-bootstrap";
import { BiImport } from "react-icons/bi";
import { FiEdit, FiTrash2 } from "react-icons/fi";
import ButtonComponent from "../../../../app/common-components/ButtonComponent";
import CustomOffCanvas from "../../../../app/common-components/CustomOffCanvas";
import CustomSelectDropDown from "../../../../app/common-components/CustomSelectDropDown";
import DiscardChanges from "../../../../app/common-components/DiscardChanges";
import EmptyDrillDownOffCanvas from "../../../../app/common-components/DrillDown/EmptyDrillDownOffCanvas";
import FormRadio from "../../../../app/common-components/form/radioButton";
import Spinners from "../../../../app/common-components/Spinner";
import CompleteTableData from "../../../../app/common-components/Table/CompleteTableData";
import ShowToolTip from "../../../../app/common-components/Tooltip/showToolTip";
import TypeaheadInput from "../../../../app/common-components/TypeaheadInput";
import { hideOffCanvas, setIsOffCanvasOpen } from "../../../../app/commonSlice";
import { effciencyApi } from "../../../../app/services/efficiencyApi";
import {
  useCommonAlert,
} from "../../../../app/utilities/helpers";
import {
  downloadTemplate,
  ImportCmdbDevices,
  serverInfoListApi,
} from "../cmdb-overview/CMDBSlice";
import "../styles.scss";
import ServerConfigDrilldown from "./ServerConfigDrilldown";

export const ProjectContext = createContext();
const Serverconfig = (props) => {
  const dispatch = useDispatch();
  const {
    serverInfoListData,
    serverInfoCountData,
    serverInfoCountLoading,
    serverInfoListLoading,
    ImportCmdbDevicesDataLoading,
    templateLoading,
    templateError,
  } = useSelector((state) => state.cmdbId);
  const [pageNo, setpageNo] = useState(0);
  const [pageLimit, setpageLimit] = useState(10);
  const [searchKey, setsearchKey] = useState("");
  const calculatedPageCount = serverInfoListData?.totalCount
    ? Math.ceil(serverInfoListData?.totalCount / pageLimit)
    : 0;
  const finalPageCount = calculatedPageCount !== 0 ? calculatedPageCount : 1;
  const [showServerForm, setShowServerForm] = useState(false);
  const [drilldownLoader, setDrilldownLoader] = useState(false);
  //   const { efficiency } = useSelector((state) => state);
  // const [showServerName, setShowServerName] = useState("");
  // const [showHostName, setHostName] = useState("");
  // const [showIp, setIp] = useState("");
  // const [showOs, setOs] = useState("");
  // const [showEnvironmentName, setEnvironment] = useState("");
  const [showAppName, setAppName] = useState("");
  const [showAppCode, setAppCode] = useState("");
  const [getId, setGetId] = useState("");
  const [getRowId, setGetRowId] = useState("");
  const { serverLoadPage } = useSelector((state) => state.configuration);
  const [isBodyOpen, setisBodyOpen] = useState(false);
  const [showtype, settype] = useState("");
  const [DeviceNameerrorMessage, setDeviceNameErrorMessage] = useState("");
  const [TypeerrorMessage, setTypeErrorMessage] = useState("");
  const [HostNameerrorMessage, setHostNameErrorMessage] = useState("");
  const [OperatingSystemerrorMessage, setOperatingSystemErrorMessage] =
    useState("");
  const [IPerrorMessage, setIPErrorMessage] = useState("");
  const [EnvironmenterrorMessage, setEnvironmentErrorMessage] = useState("");
  const [showDeviceName, setShowDeviceName] = useState("");
  const [showType, setShowType] = useState("");
  const [showHost, setShowHostName] = useState("");
  const [showOperatingSystem, setShowOperatingSystem] = useState("");
  const [showIP, setShowIP] = useState("");
  const [showEnvironment, setShowEnvironment] = useState("");
  const [showDeviceError, setshowDeviceError] = useState("");
  const [showTypeNameError, setshowTypeNameError] = useState("");
  const [showHostError, setshowHostError] = useState("");
  const [showOperatingError, setshowOperatingError] = useState("");
  const [showIPNameError, setshowIPNameError] = useState("");
  const [showEnvironmentNameError, setshowEnvironmentNameError] = useState("");

  const [Serverstate, setServerstate] = useState({
    applicationConfig: false,
    appConfigTitle: "",
    cmdbId: "",
    serverList: {},
  });
  const [serverLoad, setServerLoad] = useState(false);
  const [state, setState] = useState({
    page: 0,
    limit: 10,
    serverTableData: [],
    count: 0,
    importModal: false,
    newApplication: false,
    projectId: "",
    file: "",
    loading: false,
    fileInfo: "",
    fileError: "",
    deleteModalOpen: false,
    newProvision: false,
    loadPage: false,
    modalOpen: false,
    modalOpen1: false,
    modalOpenInfo: false,
    modalbodyOpen: true,
    modalBodyTrigger: false,
    modalbodyOpenInfo: false,
    deleteId: "",
    deviceAddPopup: false,
    deviceactionType: "Add",
    addBodyOpenServer: false,
    conformationPop: false,
  });
  const { callCommonAlert, hideCommonAlert } = useCommonAlert();
  const serverListData = state.serverTableData;
  const { state: locationState } = useLocation();
  const payloadid = locationState?.id;

  if (!payloadid) {
    // window.location.replace("/efficiency/appConfig");
  }

  const navigate = useNavigate();
  const [getServersInfoCMDB] = effciencyApi.useGetServersInfoCMDBMutation();
  const [getServerInfoSaveCMDB] =
    effciencyApi.useGetServerInfoSaveCMDBMutation();
  const [getServerInfodelete] = effciencyApi.useGetServerInfodeleteMutation();
  const [getServersInfoGetID] = effciencyApi.useGetServersInfoGetIDMutation();
  // const [getCheckServerName] = effciencyApi.useGetCheckServerNameMutation();
  // const [getServerCount] = effciencyApi.useGetServerCountMutation();

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const [currentAction, setCurrentAction] = useState("");
  const [getType, setGetType] = useState("");
  const [search, setSearch] = useState([]);
  // license config
  const licensedetailsclose = async () => { };

  // const{
  //   groupMembersData
  // } = ;

  const modalbodyOpen = () => (
    <>
      <Modal.Header closeButton>
        <Modal.Title>
          <h3 className="fw-bolder">Licence Details</h3>
        </Modal.Title>
      </Modal.Header>
      <div className="row">
        {" "}
        <div className="col-md-6">
          {" "}
          <label>Licence Description </label>
          <Input
            containerClassName="frmgroup"
            type={"text"}
            name={"Licence Description"}
            value={state?.formFields?.["Licence Description"]}
            placeholder={"Enter Licence Description"}
            autoComplete={"off"}

          // onChange={(e) => {
          //   handleOnChange(e.target.name, e.target.value.trim());
          // }}
          />
        </div>
        <div className="col-md-6">
          <label>License Entitled </label>
          <Input
            containerClassName="frmgroup"
            type={"text"}
            name={"License entitled"}
            value={state?.formFields?.["License entitled"]}
            placeholder={"License entitled"}
            autoComplete={"off"}
          // onChange={(e) => {
          //   handleOnChange(e.target.name, e.target.value.trim());
          // }}
          />
        </div>
      </div>
      <label>License include</label>
      <div className="toolboard-row">
        <div className="toolleft">
          <div className="groups_title">{/* <h4>{group.groups}</h4> */}</div>
          {/* {userAdd(group.groups)} */}
        </div>

        <div className="toolright">
          <a
            className="outline-button"
          // onClick={() => handleAdduserShow(idx)}
          >
            <span>+</span> Add User
          </a>
          <div className="adduser-row active">
            <div className="groupinput">
              <input
                className="search_class "
                type="text"
                placeholder="Type Operating System Name"
              />
            </div>
            <div className="">
              <button className="solid-btn" data-testid="addUserButton">Add</button>
              <div className={`adduser-row`}>
                <div className="groupinput">
                  <TypeaheadInput
                    // id={group.groups}
                    customClassName="addMemberInput"
                    // options={search}
                    inputOnly={true}
                    minLength={1}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-end">
        <div>
          {" "}
          <button className="solid-btn graybtn clsbusiness px-3">
            Cancel{" "}
          </button>
        </div>
        <div>
          {" "}
          <button className="solid-btn svebusiness" data-testid="restoreLicenseBtn" >Restore </button>{" "}
        </div>
        <div>
          {" "}
          <button size="sm" className="solid-btn px-4 manageEnabled" data-testid="saveLicenseBtn" >
            Save{" "}
          </button>{" "}
        </div>
      </div>
    </>
  );

  const handleCloseInfo = () => {
    setState({
      ...state,
      modalbodyOpenInfo: false,
    });
  };
  const addmodalCloseServer = () => {
    setState((state) => ({
      ...state,
      addBodyOpenServer: true,
    }));
  };
  const addBodyCancelServer = () => {
    setState({
      ...state,
      addBodyOpenServer: false,
    });
  };
  const addBodyServer = () => {
    return (
      <>
        <DiscardChanges
          title={currentAction === "edit" ? "edit" : "add"}
          discardClick={addserverclose}
          cancelClick={addBodyCancelServer}
        />
      </>
    );
  };

  let serverInfoData = "";

  serverInfoData = serverListData.data?.map((serverInfo) => ({
    deviceName: serverInfo.serverName,
    hostName: serverInfo.hostName,
    ip: serverInfo.ip,
    environment: serverInfo.environment,
    operatingSystem: serverInfo.operatingSystem,
    appName: serverInfo.appName,
    appCode: serverInfo.appCode,
    id: serverInfo.id,
    type: serverInfo.type,
  }));

  const payload = {
    keyword: searchKey,
  };

  const fetchData = async () => {
    dispatch(
      serverInfoListApi({
        pageNumber: pageNo,
        itemsPerPage: pageLimit,
        payload,
      })
    );
    getServersInfoCMDB()
      .unwrap(
        setState((state) => ({
          ...state,
          loading: true,
        }))
      )
      .then((data) => {
        setState((state) => ({
          ...state,
          loading: false,
          serverTableData: data,
        }));
      });
  };

  const fetchDataServer = async () => {
    getServersInfoGetID()
      .unwrap(
        setState((state) => ({
          ...state,
          loading: true,
        }))
      )
      .then((data) => {
        setState((state) => ({
          ...state,
          loading: false,
          serverTableData: data,
        }));
      });
  };

  useEffect(() => {
    fetchData();
    fetchDataServer();
  }, [pageLimit, pageNo, searchKey]);

  const OpenServerConfig = (row) => {
    setCurrentAction("");
    dispatch(
      setIsOffCanvasOpen({
        isDrilldownOpen: true,
        dropDownMenuOptions: false,
        title: "Configuration",
        // noScroll:true,
        customClass: "mxh-90vh",
        selectedData: (
          <ServerConfigDrilldown
            IP={row.original.ip}
            ID={row.original.id}
            HostName={row.original.hostName}
            onTablereload={() => {
              fetchData(), fetchDataServer();
            }}
          />
        ),
      })
    );
  };

  const columns = [
    {
      Header: "Device Name",
      accessor: "deviceName",
    },
    {
      Header: "Type",
      accessor: "type",
      Cell: ({ value }) => {
        return <>{value ? value : "-"}</>;
      },
    },

    {
      Header: "Hostname",
      accessor: "hostName",
    },
    {
      Header: "Operating System",
      accessor: "operatingSystem",
    },
    {
      Header: "IP",
      accessor: "ip",
    },
    {
      Header: "Environment",
      accessor: "environment",
    },
    {
      Header: "Application Name",
      accessor: "appName",
      Cell: ({ value }) => {
        return <>{value ? value : "-"}</>;
      },
    },
    {
      Header: "Last Fetched for VM",
      accessor: "lastFetchedDateForVulnerability",
      thClassName: "wrap_class",
      tdClassName: "text-center",
      Cell: ({ value }) => {
        return <>{value ? value : "-"}</>;
      },
    },
    {
      Header: "Last Scanned for VM",
      accessor: "lastScannedDateForVulnerability",
      thClassName: "wrap_class",
      tdClassName: "text-center",
      Cell: ({ value }) => {
        return <>{value ? value : "-"}</>;
      },
    },
    {
      Header: "Last Fetched for CIS",
      accessor: "lastFetchedDateForCISBenchMark",
      thClassName: "wrap_class",
      tdClassName: "text-center",
      Cell: ({ value }) => {
        return <>{value ? value : "-"}</>;
      },
    },
    {
      Header: "Last Scanned for CIS",
      accessor: "lastScannedDateForCISBenchMark",
      thClassName: "wrap_class",
      tdClassName: "text-center",
      Cell: ({ value }) => {
        return <>{value ? value : "-"}</>;
      },
    },
    {
      Header: "Actions",
      accessor: "Action",
      tdClassName: "text-center",
      thClassName: "text-center",
      disableSortBy: true,

      Cell: ({ row, value }) => (
        <div className="actionsBtn d-flex justify-content-center">
          {" "}
          <div className="actcol">
            <FiEdit
              title="Edit"
              className="iconStyleActions"
              data-testid="editIcon"
              onClick={() => {
                setServerstate((state) => ({
                  ...state,
                  applicationConfig: true,
                  appConfigTitle: "Application",
                  editId: row.original.id,
                }));
                setState({
                  ...state,
                  deviceactionType: "Edit",
                });
                openserver("edit", row.original.id);
              }}
            />
          </div>
          <div className="actcol">
            <FiTrash2
              title="Delete"
              className="iconStyleActions"
              data-testid={"deleteIcon"}
              onClick={() => {
                setState((state) => ({
                  ...state,
                  modalOpen: true,
                  deleteId: row.original.id,
                }));
              }}
            />
          </div>
        </div>
      ),
    },
  ];

  const openserver = async (action, id) => {
    setshowDeviceError(false);
    setshowTypeNameError(false);
    setTypeErrorMessage("");
    setshowHostError(false);
    setshowOperatingError(false);
    setshowIPNameError(false);
    setshowEnvironmentNameError(false);

    if (action == "edit") {
      const filteredServers = serverInfoListData?.data
        .map((serverInfo) => {
          if (serverInfo.id == id) {
            setShowDeviceName(serverInfo.deviceName);
            setShowType(serverInfo.type);
            setShowHostName(serverInfo.hostName);
            setShowOperatingSystem(serverInfo.operatingSystem);
            setShowIP(serverInfo.ip);
            setShowEnvironment(serverInfo.environment);
          }
          return {
            deviceName: serverInfo.deviceName,
            hostName: serverInfo.hostName,
            operatingSystem: serverInfo.operatingSystem,
            ip: serverInfo.ip,
            environment: serverInfo.environment,
            appName: serverInfo.appName,
            appCode: serverInfo.appCode,
            id: serverInfo.id,
            type: serverInfo.type,
          };
        })
        .filter((server) => server.id === id);
      settype(filteredServers.map((data) => data.type).join(","));
      setAppName(filteredServers.map((data) => data.appName).join(","));
      setAppCode(filteredServers.map((data) => data.appCode).join(","));
      setGetId(filteredServers.map((data) => data.id).join(","));
      setGetType(filteredServers.map((data) => data.type).join(","));
      setCurrentAction("edit");
      setIsSidebarOpen(true);
    } else {
      settype("");
      setAppName("");
      setAppCode("");
      setShowType("");
      setTypeErrorMessage("");
      setCurrentAction("add");
      setState((state) => ({
        ...state,
        type: "",
      }));
    }
    dispatch(
      setIsOffCanvasOpen({
        isDrilldownOpen: true,
        isDropDownhide: true,
      })
    );
  };

  const onNavigate = (e, url) => {
    e.preventDefault();
    navigate(url);
  };
  let hasError = false;

  const handleSaveAdd = () => {
    const ipRegex =
      /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$|^([0-9a-fA-F]{1,4}::?){1,7}([0-9a-fA-F]{1,4}|:)$/;
    if (showDeviceName.trim() === "") {
      setDeviceNameErrorMessage("Device Name should not be empty");
      setshowDeviceError(true);
      hasError = true;
    } else if (!/^[ a-zA-Z0-9][a-zA-Z0-9-_ ]*$/.test(showDeviceName)) {
      setshowDeviceError(true);
      setDeviceNameErrorMessage("Please enter a vaild Device Name");
      hasError = true;
    } else if (showDeviceName.startsWith(" ")) {
      setshowDeviceError(true);
      setDeviceNameErrorMessage(
        "Device Name should not start with a empty space"
      );
      hasError = true;
    }
    if (showType.trim() === "") {
      setTypeErrorMessage("Type should not be empty");
      setshowTypeNameError(true);
      hasError = true;
    }
    if (showHost.trim() === "") {
      setHostNameErrorMessage("Hostname should not be empty");
      setshowHostError(true);
      hasError = true;
    }
    // else if (showHost.includes(' ')) {
    //   setshowHostError(true);
    //   setHostNameErrorMessage('Space is not allowed in the Host Name');
    //   hasError = true;
    // }
    else if (!/^[ a-zA-Z0-9][a-zA-Z0-9-_ ]*$/.test(showHost)) {
      setshowHostError(true);
      setHostNameErrorMessage(
        "Special Characters are not allowed in the Hostname (Except ' - ' & ' _ ')"
      );
      hasError = true;
    } else if (showHost[0] === "-") {
      setshowHostError(true);
      setHostNameErrorMessage("Hostname should not start with a hyphen");
      hasError = true;
    } else if (showHost[0] === ".") {
      setshowHostError(true);
      setHostNameErrorMessage("Hostname should not start with a period");
      hasError = true;
    } else {
      setshowHostError(false);
      setHostNameErrorMessage("");
    }
    if (showOperatingSystem.trim() === "") {
      setOperatingSystemErrorMessage("Operating System should not be empty");
      setshowOperatingError(true);
      hasError = true;
    } else if (showOperatingSystem.startsWith(" ")) {
      setshowOperatingError(true);
      setOperatingSystemErrorMessage(
        "Operating System should not start with a empty space"
      );
      hasError = true;
    } else if (
      !/^[a-zA-Z0-9-.\s]+$/.test(showOperatingSystem) ||
      !/[a-zA-Z]/.test(showOperatingSystem)
    ) {
      setshowOperatingError(true);
      setOperatingSystemErrorMessage("Please enter a valid Operating System");
      hasError = true;
    }
    if (showIP.trim() === "") {
      setIPErrorMessage("IP should not be empty");
      setshowIPNameError(true);
      hasError = true;
    } else if (!ipRegex.test(showIP)) {
      setIPErrorMessage("Please enter a valid IP");
      setshowIPNameError(true);
      hasError = true;
    } else if (showIP.startsWith(" ")) {
      setIPErrorMessage("IP should not start with a empty space");
      setshowIPNameError(true);
    }
    if (showEnvironment.trim() === "") {
      setEnvironmentErrorMessage("Environment should not be empty");
      setshowEnvironmentNameError(true);

      hasError = true;
    } else if (showEnvironment.startsWith(" ")) {
      setshowEnvironmentNameError(true);
      setEnvironmentErrorMessage(
        "Environment Name should not start with a empty space"
      );
      hasError = true;
    } else if (!/^[a-zA-Z0-9-\s]+$/.test(showEnvironment)) {
      setshowEnvironmentNameError(true);
      setEnvironmentErrorMessage("Please enter a valid Environment");
      hasError = true;
    }
    if (!hasError) {
      setState({
        ...state,
        deviceAddPopup: true,
      });
    }
  };

  const confirmAddDevice = (action) => {
    if (!hasError) {
      setState({
        ...state,
        deviceAddPopup: false,
        deviceactionType: action,
      });
      const payload = {
        deviceName: showDeviceName,
        hostName: showHost,
        ip: showIP,
        id: action === "Edit" ? parseInt(getId) : 0,
        type: showType,
        environment: showEnvironment,
        operatingSystem: showOperatingSystem,
      };
      try {
        setDrilldownLoader(true);
        getServerInfoSaveCMDB({ payload })
          .then((response) => {
            setDrilldownLoader(false);

            console.log("Full API Response:", response); // For debugging

            // Handle nested data structure
            const actualData = response?.data || response;
            const statusCode =
              actualData?.statusCodeValue || actualData?.statusCode;
            let message =
              actualData?.body || actualData?.message || actualData?.error;
            if (typeof message === "object") {
              message = JSON.stringify(message);
            }

            console.log("Extracted data:", { actualData, statusCode, message }); // For debugging

            const cleanup = () => {
              setState((state) => ({
                ...state,
                modalOpen: false,
                deviceAddPopup: false,
              }));
              hideCommonAlert();
            };

            if (statusCode === 200) {
              addserverclose();
              callCommonAlert("success", message);
              dispatch(
                setIsOffCanvasOpen({
                  isDrilldownOpen: false,
                  isDropDownhide: false,
                })
              );
              fetchData();
            } else {
              callCommonAlert(
                "error",
                message || "Something went wrong. Please try again."
              );
            }

            cleanup();
          })
          .catch((error) => {
            console.error("API Error:", error);
            setDrilldownLoader(false);
            callCommonAlert(
              "error",
              "Network error. Please check your connection."
            );
            setState((state) => ({
              ...state,
              modalOpen: false,
              deviceAddPopup: false,
            }));
          });
      } catch (error) { }
    }
  };

  const handleDevicePopupClose = () => {
    setState({
      ...state,
      deviceAddPopup: false,
      deviceactionType: "Add",
    });
  };
  const handleSaveConfirm = () => { };

  const addDevicePopup = () => {
    const action = state.deviceactionType;
    return (
      <>
        <h4 className="delete-h">
          {action == "Add" ? "Add New Device" : "Update Device"}
        </h4>
        <p>
          Please confirm that the Hostname belongs to the specified IP address.
        </p>

        <div className="btnswrap btn-dlt cloudpadding">
          <ButtonComponent
            text="Cancel"
            className={"cancelBtnStyle gray btn"}
            data-testid="cancelAddDeviceBtn"
            onClick={() => {
              handleDevicePopupClose();
            }}
          />
          <ButtonComponent
            text="Confirm"
            className={"btnStyle btn btn-primary"}
            data-testid="confirmAddDeviceBtn"
            // onClick={() => { action == "Add" ? confirmAddDevice() : confirmEditDevice() }}
            onClick={() => {
              confirmAddDevice(action);
            }}
          />
        </div>
      </>
    );
  };

  const submitSave = useCallback(async () => {
    // if (currentAction === "edit") {
    //   handleSaveEdit();
    // } else {
    handleSaveAdd();
    // }
  });

  const addserverclose = async () => {
    dispatch(hideOffCanvas(false));
    // setShowServerForm(false)
    // setShowServerAddBtn(true)
    setIsSidebarOpen(false);
    resetInput("");
    addBodyCancelServer();
    setState((state) => ({
      ...state,
      conformationPop: false,
    }));
  };
  const onDeleteData = (data) => {
    setState((state) => ({
      ...state,
      projectId: data.id,
      deleteModalOpen: false,
    }));
  };

  const deleteId = () => {
    getServerInfodelete({ id: state.deleteId })
      .unwrap(setServerLoad(true))
      .then((data) => {
        console.log("data", data);
        setServerLoad(false);
        if (data?.statusCodeValue === 201) {
          callCommonAlert("success", data?.body);
          setState((state) => ({
            ...state,
            modalOpen: false,
          }));
          setpageNo(0);
          fetchData();
          hideCommonAlert();
        } else if (data?.statusCodeValue === 400) {
          callCommonAlert(
            "error",
            typeof data?.body === "object"
              ? JSON.stringify(data?.body)
              : data?.body
          );
          setState((state) => ({
            ...state,
            modalOpen: false,
          }));
          hideCommonAlert();
        } else if (data?.error) {
          callCommonAlert("error", "Something went wrong. Please try again.");
          setState((state) => ({
            ...state,
            modalOpen: false,
          }));
          hideCommonAlert();
        }
      });
  };

  const modalBody = () => (
    <>
      {serverLoad ? (
        <Spinners />
      ) : (
        <div>
          <h4 className="delete-h">Delete Device Configuration</h4>
          <p>Are you sure you would like to delete the device configuration?</p>
          <div className="btnswrap btn-dlt ">
            <ButtonComponent
              text="Cancel"
              className={"cancelBtnStyle btn btn-primary"}
              data-testid="cancelDeleteDeviceBtn"
              onClick={handleClose}
            />
            <ButtonComponent
              text="Delete"
              className={"btnStyle btn btn-primary"}
              data-testid="confirmDeleteDeviceBtn"
              onClick={() => deleteId()}
            />
          </div>
        </div>
      )}
    </>
  );
  const handleClose = () => {
    setState({
      ...state,
      modalOpen: false,
    });
    hideCommonAlert();
  };
  const handleClose1 = () => {
    setState({
      ...state,
      modalOpen1: false,
    });
  };

  const resetInput = () => {
    // setShowServerName("");
    // setHostName("");
    // setIp("");
    // setOs("");
    // setEnvironment("");
    setGetId("");
    setGetType("");
  };

  let totalPages = Math.ceil(state.count / state.limit);
  const clickbtn = () => {
    setShowDeviceName("");
    setShowEnvironment("");
    setShowIP("");
    setShowOperatingSystem("");
    setShowHostName("");
    setGetType("");
    setState({
      ...state,
      deviceactionType: "Add",
      conformationPop: false,
    });
    return openserver("add", 0);
  };
  const handleImportModalClose = () => {
    setState({
      ...state,
      importModal: false,
    });
  };
  const postImportCmdb = (importTypeInteger) => {
    if (!state.file) {
      document.getElementById("Errmsg").innerHTML = "*Please choose a file";
      return;
    }

    const formData = new FormData();
    formData.append("file", state.file);

    // Determine URL based on import type
    const url =
      importTypeInteger === 0
        ? "/cmdb/api/v1/serverConfigInfo/saveServersFromCSV"
        : "/tenable/api/v1/assetConfiguration/saveAssetConfigurationFromCsv";

    dispatch(ImportCmdbDevices({ formData, url }))
      .then((data) => {
        const payload = data?.payload;
        let msg = payload?.body;
        if (typeof msg === "object") {
          msg = JSON.stringify(msg);
        }

        if (payload?.statusCodeValue === 200) {
          callCommonAlert("success", msg);
          fetchData();
        } else if (payload?.statusCodeValue === 400) {
          callCommonAlert("error", msg);
        } else {
          callCommonAlert("error", "Something went wrong. Please try again");
        }

        hideCommonAlert();

        // reset state
        setState((state) => ({
          ...state,
          importModal: false,
          loadPage: true,
          file: "",
          fileInfo: "",
          fileError: "",
        }));
      })
      .catch((error) => console.log("API Error:", error));
  };

  const ProjectSample = (importTypeInteger) => {
    dispatch(downloadTemplate(importTypeInteger));
  };

  const [importType, setImportType] = useState(0);
  const importModal = () => (
    <>
      <h4>Import CSV</h4>
      <div className="frmgroup radiogroup d-flex justify-content-start w-100">
        {/* <label>Secure</label> */}
        <FormRadio
          containerClassName={"form-check-inline"}
          checked={importType === 0}
          name="DeviceBulkImport"
          onChange={() => setImportType(0)}
          label="Devices"
        />

        <FormRadio
          containerClassName={"form-check-inline"}
          checked={importType === 1}
          name="AssetConfigurationImport"
          onChange={() => setImportType(1)}
          label="Asset Configuration"
        />
      </div>
      <div className="errors">{state.fileError}</div>
      <form id="upload-file-form" className="hide-ele">
        <div className="col-lg-12 upload-file-model">
          <label
            className="btn btn-submit chaos-btn ml-0 upload_btn"
            htmlFor="upload-file-input"
          >
            <input
              id="upload-file-input"
              data-testid="uploadFileInput"
              accept=".csv"
              type="file"
              name="file"
              className="hide-ele"
              onChange={(event) => {
                const file = event.target.files[0];
                setState({
                  ...state,
                  file: file || "",
                  fileInfo: file ? file.name : "",
                  fileError: "",
                });
              }}
            />
          </label>
          <span
            className="label label-default hide filepath"
            id="upload-file-info"
          >
            {state.fileInfo !== ""
              ? "C:\\fakepath\\" + `${state.fileInfo}`
              : ""}
          </span>
          <div className="col-md-12 upload_example">
            <a onClick={() => ProjectSample(importType)}>
              {importType === 0 ? `Devices ` : `Asset Configuration `}
              Template.csv
            </a>
          </div>
        </div>
      </form>
      <div className="btnswrap">
        <ButtonComponent
          text="Cancel"
          onClick={handleImportModalClose}
          className="cancelBtnStyle"
        />
        <ButtonComponent
          text="Submit"
          onClick={() => postImportCmdb(importType)}
        />
      </div>
    </>
  );
  const btnData = [
    {
      text: "Add",
      function: clickbtn,
      className: "solid-btn",
    },
    {
      text: "Import",
      btnComponent: (
        <div>
          <span className="d-inline-block Custom_tooltip" tabIndex="0">
            {/* Use ShowTooltip for the tooltip functionality */}
            <ShowToolTip
              epssClassName="Custom_tooltip"
              value="Import as CSV"
              placement="top"
            />
            {/* Export Button */}
            <ButtonComponent
              data-testid="vmCsvBtn"
              className={`serverTableAddList btnStyle export-btn`}
              style={{ minWidth: "3px", marginLeft: "0px" }}
              text={
                <span>
                  <BiImport style={{ fontSize: "21px" }} />
                </span>
              }
              onClick={() => {
                setState({
                  ...state,
                  importModal: true,
                  // file: "",
                  // fileInfo: "",
                });
              }}
            />
          </span>
        </div>
      ),
    },
    // {
    //   text: "OS License Config",
    //   function: (e) => {
    //     onNavigate(
    //       e,
    //       "/configuration/cmdb/Devices/licenseconfigpage"
    //     );
    //   },
    // }
  ];

  const handleTriggerClose = () => {
    setState({
      ...state,
      modalBodyTrigger: false,
    });
  };
  const handleShowManage = () => {
    setState({
      ...state,
      modalBodyTrigger: true,
    });
  };
  const handleOnChange = (value) => {
    // setState((state) => ({
    //   ...state,
    //   type: value,
    // }));
    setGetType(value);
    setShowType(value);
    setTypeErrorMessage("");
    setshowTypeNameError(false);
    setState((state) => ({ ...state, conformationPop: true }));
  };
  const modalBodyTrigger = () => (
    <>
      <h4 className="delete-h">Trigger Devices Scan</h4>
      <p>
        Are you sure you want to Trigger the Scan for the Devices,as this action
        will impact the Device configuration?
      </p>
      <div className="btnswrap btn-dlt">
        <ButtonComponent
          text="Cancel"
          className="cancelBtnStyle gray btn"
          onClick={() => {
            handleTriggerClose();
          }}
        />
        <ButtonComponent
          text="Trigger"
          className="btnStyle btn btn-primary"
          //onClick={() => {handleTrigger()}}
          onclick={handleTriggerClose}
        />
      </div>
    </>
  );
  const options = [
    { value: "Network", label: "Network" },
    { value: "FireWall", label: "FireWall" },
    { value: "Server", label: "Server" },
  ];

  function getLimit(limit) {
    setpageLimit(limit);
    setpageNo(0);
  }
  function getPage(pageNo) {
    setpageNo(pageNo);
  }
  function getSearchKey(key) {
    setpageNo(0);
    setpageLimit(10);
    setsearchKey(key);
  }
  const DeviceNameChange = (e) => {
    setShowDeviceName(e.target.value);
    setDeviceNameErrorMessage("");
    setshowDeviceError(false);
    setState((state) => ({ ...state, conformationPop: true }));
  };

  const HostNameChange = (e) => {
    setShowHostName(e.target.value);
    setHostNameErrorMessage("");
    setshowHostError(false);
    setState((state) => ({ ...state, conformationPop: true }));
  };
  const OperatingSystemChange = (e) => {
    setShowOperatingSystem(e.target.value);
    setOperatingSystemErrorMessage("");
    setshowOperatingError(false);
    setState((state) => ({ ...state, conformationPop: true }));
  };
  const IPChange = (e) => {
    setShowIP(e.target.value);
    setIPErrorMessage("");
    setshowIPNameError(false);
    setState((state) => ({ ...state, conformationPop: true }));
  };
  const EnvironmentChange = (e) => {
    setShowEnvironment(e.target.value);
    setEnvironmentErrorMessage(false);
    setshowEnvironmentNameError(false);
    setState((state) => ({ ...state, conformationPop: true }));
  };
  return (
    <>
      <ProjectContext.Provider value={{ state, setState }}>
        <CustomModal
          modalBody={importModal}
          modalHide={handleImportModalClose}
          modalOpen={state.importModal}
        />
        <CustomModal
          modalOpen={state.modalOpen}
          modalBody={modalBody}
          modalTitle={"Delete Configuration"}
          closeBtn={false}
          closeBtnFuc={handleClose}
        />
        <CustomModal
          modalOpen={state.modalBodyTrigger}
          modalBody={modalBodyTrigger}
          modalHide={handleTriggerClose}
          closeBtn={false}
          closeBtnFuc={handleTriggerClose}
        />
        {/* <DrillDownOffCanvas
          customClass={"flowblock toolwrap custom_scroll"}
          subHeading={"Please enter your Project data."}
        /> */}
        <EmptyDrillDownOffCanvas />
      </ProjectContext.Provider>
      <div>
        <div className="btnwrap d-flex justify-content-between m-0 device-licensce">
          {/* <ButtonComponent
            text="Back"
            onClick={() => {
              navigate("/configuration/cmdb");
            }}
            style={{visibility: "hidden"}}
          /> */}
          <div className="d-flex justify-content-end me-2">
            {/* <div>
              <input type="text"
                className="search_class "


                placeholder="Search" />
            </div> */}
            <div>
              {/* <button
                className="solid-btn "
                onClick={(e) =>
                  onNavigate(
                    e,
                    "/configuration/cmdb/Serverconfig/licenseconfigpage"
                  )
                }
              >
                OS license config
              </button> */}
            </div>
            {/* <div>
              <ButtonComponent
                text="Trigger Scan"
                onClick={() => {
                  handleShowManage();
                }}
                className="btnStyle triggerScan"
              />
            </div> */}
            {/* <div>
              <ButtonComponent
                text="New Provision"
                onClick={(e) => {
                  onNavigate(
                    e,
                    "/configuration/cmdb/Devices/newprovisionpage"
                  );
                }}
              />
            </div> */}
            {/* <div >
              {showServerAddBtn && (
                <button
                  className="solid-btn "
                  onClick={() => openserver("add", 0)}
                >
                  Add New
                </button>
              )}
            </div> */}
            {/* <div className="mr-22">
            </div> */}
          </div>
        </div>
        <div className="row">
          <div
            id="tableCol"
            style={{
              marginRight: showServerForm ? "75%" : "0",
              width: showServerForm ? "75%" : "100%",
            }}
          >
            <div className="grid-table">
              {/* {serverInfoCountLoading || serverInfoListLoading ? (
                <Spinners />
              ) : ( */}
              <>
                {/* <TablePaginate
                  headers={Headers}
                  hasAction
                  body={state.serverTableData}
                  isPagination={true}
                  count={state.count}
                  onPageChange={(page) => setState({ ...state, page })}
                  onGetLimit={(limit) => setState({ ...state, limit, page: 0 })}
                  currentPage={state.page}
                  onDelete={onDeleteData}
                  Btnadd={!showServerForm ? Btnadd : null} // Conditionally pass Btnadd based on showserverform
                  limit={10}
                /> */}
                <CompleteTableData
                  isLoading={serverInfoListLoading}
                  data={serverInfoListData?.data || []}
                  columns={columns}
                  onPageLimitChange={getLimit}
                  onPageNoChange={getPage}
                  onSearch={getSearchKey}
                  curentPageNumber={pageNo}
                  pageLimit={pageLimit}
                  searchKey={searchKey}
                  totalPageCount={finalPageCount}
                  listCount={serverInfoListData?.totalCount}
                  btnData={btnData}
                  moveSearchToEnd={true}
                />
              </>

              {/* )} */}
              {/* <Pagination 
               totalPages={totalPages}
              /> */}
            </div>
          </div>
          {!isEmpty(currentAction) ? (
            <CustomOffCanvas className="custom-off-canvas">
              <h3
                className="flowhead p-0-5"
                id="updatehead"
                style={{ display: "block" }}
              >
                {currentAction === "edit" ? "Update Device" : "Add New Device"}{" "}
              </h3>
              {drilldownLoader ? (
                <Spinners />
              ) : (
                <>
                  <Row className=" m-0">
                    <Col>
                      <div className="mb-3">
                        <Input
                          type="text"
                          label="Device Name*"
                          name="Device Name"
                          error={showDeviceError}
                          errorMessage={DeviceNameerrorMessage}
                          placeholder="Enter Device Name"
                          autoComplete={"off"}
                          onChange={DeviceNameChange}
                          containerClassName={"frmgroup validate default-input"}
                          value={showDeviceName}
                        />

                        {/* <ServerListDataList /> */}
                      </div>
                    </Col>

                    <Col>
                      <div className="mb-3 appConfigAddNew ">
                        <label>Type<span className="RedHighlight">*</span></label>
                        <span
                          className={showTypeNameError ? "TypeHeadBorder" : ""}
                        >
                          <span className="customDropdownTypeHead">
                            {TypeerrorMessage}
                          </span>
                          <CustomSelectDropDown
                            placeholder="Type"
                            // labelName={"Type"}
                            containerClassName={
                              "frmhead undefined serverInfoMargin"
                            }
                            name={"type"}
                            options={options}
                            // value={getType ? { label: getType } : ""}
                            hideSelectedOptions={false}
                            onChange={(value) => {
                              handleOnChange(value.value);
                            }}
                            value={showType}
                          // isDisabled={currentAction === "edit"}
                          />
                        </span>
                        {/* <Input
                        // type="text"
                        // label="Type"
                        // name="Type"
                        error={showTypeNameError}
                        errorMessage={TypeerrorMessage}
                        //placeholder="Enter Type Name"
                        autoComplete={"off"}
                        onChange={TypeChange}
                        containerClassName={"frmgroup validate default-input"}
                        value={showType}
                  />  */}
                      </div>
                    </Col>
                  </Row>
                  <Row className=" m-0">
                    <Col>
                      <div className="mb-3">
                        <Input
                          type="text"
                          label="Hostname*"
                          name="Host Name"
                          error={showHostError}
                          errorMessage={HostNameerrorMessage}
                          placeholder="Enter Hostname"
                          autoComplete={"off"}
                          onChange={HostNameChange}
                          containerClassName={"frmgroup validate default-input"}
                          value={showHost}
                        />
                        {/* <ServerListDataList /> */}
                      </div>
                    </Col>
                    <Col>
                      <div className="mb-3">
                        <Input
                          type="text"
                          label="Operating System*"
                          name="Operating System"
                          error={showOperatingError}
                          errorMessage={OperatingSystemerrorMessage}
                          placeholder="Enter Operating System"
                          autoComplete={"off"}
                          onChange={OperatingSystemChange}
                          containerClassName={"frmgroup validate default-input"}
                          value={showOperatingSystem}
                        />
                        {/* <ServerListDataList /> */}
                      </div>
                    </Col>
                  </Row>
                  <Row className=" m-0">
                    <Col>
                      <div className="mb-3">
                        <Input
                          type="text"
                          label="IP*"
                          name="IP"
                          error={showIPNameError}
                          errorMessage={IPerrorMessage}
                          placeholder="Enter IP"
                          autoComplete={"off"}
                          onChange={IPChange}
                          containerClassName={"frmgroup validate default-input"}
                          value={showIP}
                        />

                        {/* <ServerListDataList /> */}
                      </div>
                    </Col>
                    <Col>
                      <div className="mb-3">
                        <Input
                          type="text"
                          label="Environment*"
                          name="Environment"
                          error={showEnvironmentNameError}
                          errorMessage={EnvironmenterrorMessage}
                          placeholder="Enter Environment"
                          autoComplete={"off"}
                          onChange={EnvironmentChange}
                          containerClassName={"frmgroup validate default-input"}
                          value={showEnvironment}
                        />
                        {/* <ServerListDataList /> */}
                        <input
                          type="hidden"
                          name={"id"}
                          id="id"
                          className="form-control"
                          placeholder="id"
                          value={getId}
                          onChange={(e) => setGetId(e.target.value)}
                          maxLength="50"
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row className="m-0">
                    <Col></Col>
                    <Col>
                      <div
                        className="server-btn"
                        style={{ display: "block", justifyContent: "end" }}
                      >
                        {/* <button
                className="cancelBtnStyle btn btn-primary"
                onClick={() => addserverclose()}
              >
                Cancel
              </button> */}
                        <ButtonComponent
                          text="Cancel"
                          className={"cancelBtnStyle btn btn-primary"}
                          onClick={() => {
                            if (state.conformationPop) {
                              addmodalCloseServer();
                            } else {
                              addserverclose();
                            }
                          }}
                        />
                        {/* {currentAction === "edit" ? ' ' : <button className="solid-btn svebusiness" onClick={() => resetInput()}>Reset</button>} */}
                        {/* <button className="solid-btn" onClick={() => submitSave()} disabled={isDisabled()}>Submit</button> */}
                        {/* <Button variant="primary" size="sm" className="solid-btn px-4" onClick={() => submitSave()} disabled={isDisabled()}> {currentAction === "edit" ? " Save " : " Save "}</Button>{' '} */}
                        {/* {!showServerName ||
              !showHostName ||
              !showOs ||
              !showIp ||
              !showEnvironment ? (
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>Please fill all the above fields</Tooltip>}
                >
                  <button
                    className="btnStyle btn btn-primary"
                    onClick={() => submitSave()}
                  >
                    Save
                  </button>
                </OverlayTrigger>
              ) : (
                <button className="btnStyle btn btn-primary" onClick={() => submitSave()}>
                  Save
                </button>
              )} */}
                        <ButtonComponent
                          text="Save"
                          onClick={() => submitSave()}
                        />
                      </div>
                    </Col>
                  </Row>
                </>
              )}
            </CustomOffCanvas>
          ) : null}
        </div>
      </div>
      {/* </div> */}

      <CustomModal
        modalOpen={state.modalOpen1}
        modalBody={modalbodyOpen}
        modalHide={handleClose1}
        closeBtn={true}
        closeBtnFuc={handleClose1}
        size={"lg"}
      />
      <CustomModal
        modalOpen={state.deviceAddPopup}
        modalBody={addDevicePopup}
        modalHide={handleDevicePopupClose}
        closeBtn={true}
        closeBtnFuc={handleDevicePopupClose}
      />
      <CustomModal
        modalOpen={state.addBodyOpenServer}
        modalBody={addBodyServer}
        modalHide={addmodalCloseServer}
        closeBtn={true}
        closeBtnFuc={addBodyCancelServer}
      />
    </>
  );
};
export default Serverconfig;
